var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TemplateType, BrandingType, BrandClientService } from "../../../../../../services/modules/brand-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { BindingEngine } from "aurelia-binding";
import { LookupClientService } from "../../../../../../services/lookups/lookup-client.service";
import { BrandingLanguageBase } from "../../../branding/branding-langauage-base";
import { TokenClient } from "../../../../../../services/authentication/token-client.service";
import { BindingSignaler } from "aurelia-templating-resources";
var LotteryBrandingAssets = /** @class */ (function (_super) {
    __extends(LotteryBrandingAssets, _super);
    function LotteryBrandingAssets(notificationService, i18N, brandClientService, bindingEngine, eventAggregator, lookupClientService, tokenClient, bindingSignaler) {
        return _super.call(this, notificationService, i18N, brandClientService, bindingEngine, eventAggregator, lookupClientService, tokenClient, bindingSignaler) || this;
    }
    LotteryBrandingAssets_1 = LotteryBrandingAssets;
    LotteryBrandingAssets.prototype.getTemplateType = function () {
        return TemplateType.Assets;
    };
    LotteryBrandingAssets.prototype.getBrandingType = function () {
        return BrandingType.Images;
    };
    LotteryBrandingAssets.prototype.getKey = function () {
        return this.item.model.name;
    };
    LotteryBrandingAssets.prototype.getBrandDetails = function () {
        return {
            brandId: this.item.model.navigationInfo.brandId,
            brandName: this.item.model.navigationInfo.brandName,
            brandLanguages: this.item.model.navigationInfo.brandLanguages
        };
    };
    LotteryBrandingAssets.prototype.shouldNotFilter = function () {
        return true;
    };
    LotteryBrandingAssets.prototype.setKeys = function (model) {
        var keys = _super.prototype.setKeys.call(this, model) || [];
        var withoutWidgetBanner = keys.filter(function (x) { return x !== LotteryBrandingAssets_1.widgetBannerKey; });
        var logoIndex = withoutWidgetBanner.findIndex(function (x) { return x && x.toLowerCase().indexOf("logo") === 0; });
        if (logoIndex === -1) {
            return __spreadArray(__spreadArray([], __read(withoutWidgetBanner), false), [LotteryBrandingAssets_1.widgetBannerKey], false);
        }
        var result = __spreadArray([], __read(withoutWidgetBanner), false);
        result.splice(logoIndex + 1, 0, LotteryBrandingAssets_1.widgetBannerKey);
        return result;
    };
    var LotteryBrandingAssets_1;
    LotteryBrandingAssets.widgetBannerKey = "lottery-banner-for-widgets";
    LotteryBrandingAssets = LotteryBrandingAssets_1 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            BrandClientService, BindingEngine,
            EventAggregator, LookupClientService, TokenClient, BindingSignaler])
    ], LotteryBrandingAssets);
    return LotteryBrandingAssets;
}(BrandingLanguageBase));
export { LotteryBrandingAssets };
